
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/reservations",
      function () {
        return require("private-next-pages/customers/reservations/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customers/reservations"])
      });
    }
  